import { flow } from '@hcr/utils'

import { createSingleTicketValidity } from './createSingleTicketValidity'

export const createSingleTicketValidityString = flow(
  createSingleTicketValidity,
  ({ date, label }) => `${label} ${date}`
)
